<div class="row">
  <div class="col-12">
    <div class="row" *ngIf="Breadcrumblist != null">
      <div class="col-12 p-0 border-bottom headersize">
        <app-breadcrumb [Breadcrumblist]="Breadcrumblist"></app-breadcrumb>
      </div>
    </div>
    <div class="row py-1" style="height: 85vh !important; overflow: auto">
      <form [formGroup]="AddQuestionform">
        <div
          class="col-12"
          *ngFor="let s of selectedQuestionList; let i = index"
        >
          <!-- <div class="row">
          <div class="col-12"> -->

          <div
            class="row pt-1"
            *ngIf="
              (s.Question_Template_Type_Code === 'QTxtATxt' && s.checkedflag) ||
              (s.Question_Template_Type_Code === 'QTxt&ImgATxt' &&
                s.checkedflag)
            "
          >
            <div class="col-12">
              <div class="row px-3">
                <div class="col-3">
                  <div class="row">
                    <div class="col-12">
                      <div class="row px-1">
                        <div class="col-12 pt-1 p-0">
                          <div
                            class="row"
                            style="border: none"
                            *ngFor="
                              let s of selectedQuestionList;
                              let i = index
                            "
                          >
                            <div class="col-12">
                              <div class="d-flex t-row">
                                <div
                                  class="px-1 template"
                                  *ngIf="
                                    s.Question_Template_Type_Code ===
                                      'QTxtATxt' && s.checkedflag
                                  "
                                  [hidden]="
                                    !(
                                      s.Question_Template_Type_Code ===
                                        'QTxtATxt' && s.checkedflag
                                    )
                                  "
                                >
                                  <app-qt1-text
                                    [QuestionNo]="i + 1"
                                    Question="default1"
                                    template="{{ s.Question_Template_ID }}"
                                  >
                                  </app-qt1-text>
                                </div>
                                <div
                                  class="px-1 template"
                                  *ngIf="
                                    s.Question_Template_Type_Code ===
                                      'QTxt&ImgATxt' && s.checkedflag
                                  "
                                  [hidden]="
                                    !(
                                      s.Question_Template_Type_Code ===
                                        'QTxt&ImgATxt' && s.checkedflag
                                    )
                                  "
                                >
                                  <app-qt3-text
                                    [QuestionNo]="i + 1"
                                    Question="default1"
                                    template="{{ s.Question_Template_ID }}"
                                  ></app-qt3-text>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="row pt-2">
                            <div class="col-6 text-right pt-2 px-1">
                              <div class="d-flex flex-row-reverse">
                                <div class="p-0">Question No</div>
                              </div>
                            </div>

                            <div class="col-6 pt-1 px-1">
                              <input
                                type="text"
                                [disabled]="true"
                                formControlName="Question_ID"
                                class="form-control form-control-sm input-txt"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-6 text-right pt-2 px-1">
                          <div class="d-flex flex-row-reverse">
                            <div class="p-0 label-red">*</div>
                            <div class="p-0">Language</div>
                          </div>
                        </div>
                        <div class="col-6 pt-1 px-1">
                          <select
                            formControlName="Language_Type_Code"
                            [disabled]="
                              questionStatusTypeCode !=
                                'WIP' &&
                              questionStatusTypeCode !=
                                'Rework'
                            "
                            class="form-control form-control-sm input-txt"
                            [(ngModel)]="defaultlanguage"
                            (ngModelChange)="Editformvalidation()"
                          >
                            <option
                              [disabled]="
                                questionStatusTypeCode != 'WIP' &&
                                questionStatusTypeCode != 'Rework'
                              "
                              *ngFor="let s of getlanguage; let i = index"
                              [value]="s.Code"
                            >
                              {{ s.Description }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-6 text-right pt-2 px-1">
                          <div class="d-flex flex-row-reverse">
                            <div class="p-0 label-red">*</div>
                            <div class="p-0">Primary Usage</div>
                          </div>
                        </div>
                        <div class="col-6 pt-1 px-1">
                          <select
                            formControlName="Question_Primary_Usage_Type_Code"
                            [disabled]="
                              questionStatusTypeCode !=
                                'WIP' &&
                              questionStatusTypeCode !=
                                'Rework'
                            "
                            class="form-control form-control-sm input-txt"
                            [(ngModel)]="primaryUsageType"
                            (ngModelChange)="Editformvalidation()"
                          >
                            <option
                              [disabled]="
                                questionStatusTypeCode != 'WIP' &&
                                questionStatusTypeCode != 'Rework'
                              "
                              *ngFor="
                                let s of getquestionprimaryusagetype;
                                let i = index
                              "
                              [value]="s.Code"
                            >
                              {{ s.Description }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-7 text-right pt-1 px-1">
                          <div class="d-flex flex-row-reverse">
                            <div class="p-0 label-red">*</div>
                            <div class="p-0">Recommented Response time</div>
                          </div>
                        </div>
                        <div class="col-5 px-1">
                          <select
                            formControlName="Recommended_Response_Time_Type_Code"
                            [disabled]="
                              questionStatusTypeCode !=
                                'WIP' &&
                              questionStatusTypeCode !=
                                'Rework'
                            "
                            (ngModelChange)="Editformvalidation()"
                            class="form-control form-control-sm input-txt"
                          >
                            <option
                              *ngFor="
                                let s of getresponsetimetype;
                                let i = index
                              "
                              [disabled]="
                                questionStatusTypeCode != 'WIP' &&
                                questionStatusTypeCode != 'Rework'
                              "
                              [value]="s.Code"
                            >
                              {{ s.Description }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-7 text-right pt-2 px-1">
                          <div class="d-flex flex-row-reverse">
                            <div class="p-0 label-red">*</div>
                            <div class="p-0">Answer Type</div>
                          </div>
                        </div>
                        <div class="col-5 pt-1 px-1">
                          <select
                            formControlName="Answer_Type_Code"
                            [disabled]="
                              questionStatusTypeCode !=
                                'WIP' &&
                              questionStatusTypeCode !=
                                'Rework'
                            "
                            class="form-control form-control-sm input-txt"
                            [(ngModel)]="Answertype"
                            (ngModelChange)="Editformvalidation()"
                          >
                            <option
                              *ngFor="let s of getAnswertype; let i = index"
                              [disabled]="
                                questionStatusTypeCode != 'WIP' &&
                                questionStatusTypeCode != 'Rework'
                              "
                              [value]="s.Code"
                            >
                              {{ s.Description }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-7 text-right pt-2 px-1">
                          <div class="d-flex flex-row-reverse">
                            <div class="p-0 label-red">*</div>
                            <div class="p-0">Answer Selection Type</div>
                          </div>
                        </div>
                        <div class="col-5 pt-1 px-1">
                          <select
                            formControlName="Answer_Selection_Type_Code"
                            [disabled]="
                              questionStatusTypeCode !=
                                'WIP' &&
                              questionStatusTypeCode !=
                                'Rework'
                            "
                            class="form-control form-control-sm input-txt"
                            [(ngModel)]="AnswerSelectiontype"
                            (ngModelChange)="Editformvalidation()"
                          >
                            <option
                              [disabled]="
                                questionStatusTypeCode != 'WIP' &&
                                questionStatusTypeCode != 'Rework'
                              "
                              *ngFor="
                                let s of getAnswerSelectiontype;
                                let i = index
                              "
                              [value]="s.Code"
                            >
                              {{ s.Description }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="row">
                            <div class="col-7 text-right pt-2 px-1">
                              <div class="d-flex flex-row-reverse">
                                <div class="p-0">Parent Question No</div>
                              </div>
                            </div>
                            <div class="col-5 pt-1 px-1">
                              <input
                                type="text"
                                class="form-control form-control-sm input-txt"
                                readonly
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="row">
                            <div class="col-7 text-right pt-2 px-1">
                              <div class="d-flex flex-row-reverse">
                                <div class="p-0 label-red">*</div>
                                <div class="p-0">Relevant Region</div>
                              </div>
                            </div>
                            <div class="col-5 pt-1 px-1">
                              <select
                                formControlName="Location_ID"
                                [disabled]="
                                  questionStatusTypeCode != 'WIP' &&
                                  questionStatusTypeCode != 'Rework'
                                "
                                class="form-control form-control-sm input-txt"
                                (ngModelChange)="Editformvalidation()"
                              >
                                <option
                                  *ngFor="let s of getregiontype; let i = index"
                                  [disabled]="
                                    questionStatusTypeCode != 'WIP' &&
                                    questionStatusTypeCode != 'Rework'
                                  "
                                  [value]="s.Code"
                                >
                                  {{ s.Description }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="row">
                            <div class="col-7 text-right pt-2 px-1">
                              <div class="d-flex flex-row-reverse">
                                <div class="p-0 fw-bold">
                                  Competitive Exam Grade Question?
                                </div>
                              </div>
                            </div>
                            <div class="col-5 pt-1 px-1">
                              <div class="form-check mt-1">
                                <input
                                  type="checkbox"
                                  formControlName="Competative_Exam_Grade_Question_Ind"
                                  [disabled]="
                                    questionStatusTypeCode != 'WIP' &&
                                    questionStatusTypeCode != 'Rework'
                                  "
                                  class="form-check-input"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-5">
                  <div class="row">
                    <div class="col-7">
                      <div class="row">
                        <div class="col-12">
                          <div class="row">
                            <div class="col-6 text-right pt-1 px-1">
                              <div class="d-flex flex-row-reverse">
                                <div class="p-0 label-red">*</div>
                                <div class="p-0">Question Status</div>
                              </div>
                            </div>
                            <div class="col-6 px-1">
                              <select
                                readonly
                                formControlName="Question_Status_Type_Code"
                                class="form-control form-control-sm input-txt"
                                (change)="Editformvalidation()"
                              >
                                <option
                                  *ngFor="
                                    let s of getquestionstatustype;
                                    let i = index
                                  "
                                  [value]="s.Code"
                                >
                                  {{ s.Description }}
                                </option>
                              </select>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-12">
                              <div class="row">
                                <div class="col-6 text-right pt-2 px-1">
                                  <div class="d-flex flex-row-reverse">
                                    <div class="p-0 label-red">*</div>
                                    <div class="p-0">Candidate for GK</div>
                                  </div>
                                </div>
                                <div class="col-6 pt-1 px-1">
                                  <select
                                    formControlName="Question_Gk_Type_Code"
                                    class="form-control form-control-sm input-txt"
                                    (change)="Editformvalidation()"
                                  >
                                    <option
                                      *ngFor="let s of getquestiongktype; let i = index"
                                      [value]="s.Code"
                                    >
                                      {{ s.Description }}
                                    </option>
                                  </select>
                                </div>

                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                    <div class="col-5">
                      <div class="row">
                        <div class="col-12">
                          <div class="row" *ngIf="QuestionBodyflag">
                            <div class="col-1 text-right"></div>
                            <div class="col-11 px-2">
                              <a
                                [routerLink]="['./']"
                                (click)="StatusHistory()"
                                class="card-link Answer-card-link"
                                >Status Change History</a
                              >
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12">
                          <div class="row">
                            <div class="col-1"></div>
                            <div class="col-11 px-2">
                              <div class="form-check">
                                <input
                                  type="checkbox"
                                  [disabled]="
                                    questionStatusTypeCode != 'WIP' &&
                                    questionStatusTypeCode != 'Rework'
                                  "
                                  (click)="Allowtranslation()"
                                  [checked]="translationflag"
                                  class="form-check-input"
                                />
                                <label
                                  class="form-check-label"
                                  for="exampleCheck1"
                                  >Allow-translation</label
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="row">
                            <div class="col-1"></div>
                            <div class="col-11 px-2">
                              <div class="form-check">
                                <input
                                  type="checkbox"
                                  [disabled]="
                                    questionStatusTypeCode != 'WIP' &&
                                    questionStatusTypeCode != 'Rework'
                                  "
                                  class="form-check-input"
                                  [checked]="Multiquestionflag"
                                  (click)="Multiquestion()"
                                  [checked]="Multiquestionflag"
                                />
                                <label
                                  class="form-check-label"
                                  for="exampleCheck1"
                                  >Multi-Part Question</label
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div class="row">
                          <div class="col-5 headersize">Question Comment</div>
                          <div class="col-7"></div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <textarea
                              maxlength="4000"
                              formControlName="Comment_Text"
                              [readonly]="
                                questionStatusTypeCode != 'WIP' &&
                                questionStatusTypeCode != 'Rework'
                              "
                              [disabled]="
                                questionStatusTypeCode != 'WIP' &&
                                questionStatusTypeCode != 'Rework'
                              "
                              class="form-control"
                              id="txtdescription"
                              (ngModelChange)="Editformvalidation()"
                            ></textarea>
                          </div>
                        </div>

                        <!-- <div class="col-3 text-right pt-2 px-1">
                              <div class="d-flex flex-row-reverse">
                              <div class="p-0">Comment</div>
                              </div>
                            </div>

                            <div class="col-9 pt-1 px-1">
                              <textarea maxlength="4000"  formControlName="Comment_Text" [readonly]="questionStatusTypeCode!='WIP'&&questionStatusTypeCode!='Rework'" [disabled]="questionStatusTypeCode!='WIP'&&questionStatusTypeCode!='Rework'"
                              class="form-control" id="txtdescription" (ngModelChange)="Editformvalidation()"></textarea>
                            </div> -->
                      </div>
                    </div>
                  </div>
<div class="row" *ngIf="getQuestionByIDlist">
  <div class="col-12">
    <div class="d-flex flex-wrap gap-3 align-items-center py-2 px-1" style="background: #f9f9f9; border-radius: 8px;">

      <div *ngIf="getQuestionByIDlist[0]?.Created_By">
        <strong>Created by:</strong>
        <span>{{ getQuestionByIDlist[0]?.Created_By }}</span>
        <span class="text-muted">
          [{{ getQuestionByIDlist[0]?.Creation_Date ? (getQuestionByIDlist[0].Creation_Date | date: "dd/MM/yyyy HH:mm:ss") : '-' }}]
        </span>
      </div>

      <div *ngIf="getQuestionByIDlist[0]?.Updated_By">
        <strong>Updated by:</strong>
        <span>{{ getQuestionByIDlist[0]?.Updated_By }}</span>
        <span class="text-muted">
          [{{ getQuestionByIDlist[0]?.Updation_Date ? (getQuestionByIDlist[0]?.Updation_Date | date: "dd/MM/yyyy HH:mm:ss") : '-' }}]
        </span>
      </div>

    </div>
  </div>
</div>


                </div>
              </div>
              <div class="row">
                <div class="col-7">
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-12" *ngIf="QuestionBodyflag">
                          <div class="row">
                            <div class="col-2 headersize">Question</div>
                          </div>
                          <div class="row">
                            <div
                              class="col-12"
                              [ngClass]="{
                                'my-disable':
                                  questionStatusTypeCode != 'WIP' &&
                                  questionStatusTypeCode != 'Rework'
                              }"
                              (click)="QuestionBodypopup()"
                            >
                              <div
                                class="card"
                                style="height: 18vh !important; overflow: auto"
                              >
                                <!-- <div class="card-body" > -->

                                <div
                                  class="editor py-1 px-1"
                                  *ngIf="safehtmlStr != null"
                                >
                                  <div [innerHTML]="safehtmlStr"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-5" *ngIf="QuestionBodyflag">
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-8"></div>
                        <div class="col-4"></div>
                      </div>
                      <div class="row">
                        <div
                          class="col-12 pt-1 px-1"
                          [ngClass]="{
                            'my-disable':
                              questionStatusTypeCode !=
                                'WIP' &&
                              questionStatusTypeCode !=
                                'Rework'
                          }"
                          (click)="clickquestionusage()"
                        >
                          <div
                            class="card"
                            style="
                              height: 21vh !important;
                              overflow: auto;
                              padding-bottom: 2px;
                            "
                          >
                            <div class="card-body p-1">
                              <div class="table-responsive">
                                <table
                                  class="table table-sm table-bordered table-hover"
                                  style="margin-bottom: 0"
                                >
                                  <thead>
                                    <tr class="table-active">
                                      <th class="col-md-5 center">
                                        Exam Category
                                      </th>
                                      <th class="col-md-2 center">
                                        Difficulty
                                      </th>
                                      <th class="col-md-5 center">
                                        Question Scope
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      *ngFor="
                                        let s of getQuestionUsagelist;
                                        let i = index
                                      "
                                    >
                                      <td class="verticalcenter">
                                        {{ s.Exam_Category_Type_Name }}
                                      </td>
                                      <td class="verticalcenter">
                                        {{ s.Difficulty_Level_Type_Code }}
                                      </td>
                                      <td class="verticalcenter">
                                        {{ s.Question_Scope_Type_Name }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-6"></div>
              <div class="col-6"></div>

              <div class="col-12" *ngIf="QuestionBodyflag">
                <div class="row">
                  <div class="col-4 headersize">Answers</div>
                  <div class="col-8"></div>
                </div>
                <div class="row">
                  <div
                    class="col-12"
                    [ngClass]="{
                      'my-disable':
                        questionStatusTypeCode !=
                          'WIP' &&
                        questionStatusTypeCode !=
                          'Rework'
                    }"
                  >
                    <div class="card" style="min-height: auto; padding: 2px">
                      <div class="col-12 px-3">
                        <div class="row">
                          <div class="col-6">
                            <div class="row">
                              <div class="col-3 p-1">
                                <div class="row">
                                  <div class="col-12">
                                    <div class="d-flex justify-content-center">
                                      <div class="p-0 pt-1 headersize1">
                                        Right Answer
                                      </div>
                                      <div
                                        class="p-0"
                                        *ngIf="RightAnswer1 != null"
                                      >
                                        <!-- <button type="button" *ngIf="RightAnswer11" class="btn btn-sm bg-light border" (click)="DeleteAnswerChoice(RightAnswer1)">Delete Answer</button> -->
                                        <button
                                          *ngIf="RightAnswer11"
                                          (click)="
                                            DeleteAnswerChoice(RightAnswer1)
                                          "
                                          type="button"
                                          class="btn btn-sm py-0"
                                          style="background: transparent"
                                        >
                                          <i
                                            class="fa fa-trash label-red"
                                            style="font-size: 16px"
                                          ></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-3 p-1">
                                <div class="row">
                                  <div class="col-12">
                                    <div class="d-flex justify-content-center">
                                      <div class="p-0 pt-1 headersize1">
                                        Wrong Answer
                                      </div>
                                      <div
                                        class="p-0"
                                        *ngIf="WrongAnswer1 != null"
                                      >
                                        <!-- <button type="button" *ngIf="WrongAnswer11" class="btn btn-sm bg-light border" (click)="DeleteAnswerChoice(WrongAnswer1)">Delete Answer</button> -->
                                        <button
                                          *ngIf="WrongAnswer11"
                                          (click)="
                                            DeleteAnswerChoice(WrongAnswer1)
                                          "
                                          type="button"
                                          class="btn btn-sm py-0"
                                          style="background: transparent"
                                        >
                                          <i
                                            class="fa fa-trash label-red"
                                            style="font-size: 16px"
                                          ></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-3 p-1">
                                <div class="row">
                                  <div class="col-12">
                                    <div class="d-flex justify-content-center">
                                      <div class="p-0 pt-1 headersize1">
                                        Wrong Answer
                                      </div>
                                      <div
                                        class="p-0"
                                        *ngIf="WrongAnswer2 != null"
                                      >
                                        <!-- <button type="button" *ngIf="WrongAnswer22" class="btn btn-sm bg-light border" (click)="DeleteAnswerChoice(WrongAnswer2)">Delete Answer</button> -->
                                        <button
                                          *ngIf="WrongAnswer22"
                                          (click)="
                                            DeleteAnswerChoice(WrongAnswer2)
                                          "
                                          type="button"
                                          class="btn btn-sm py-0"
                                          style="background: transparent"
                                        >
                                          <i
                                            class="fa fa-trash label-red"
                                            style="font-size: 16px"
                                          ></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-3 p-1">
                                <div class="row">
                                  <div class="col-12">
                                    <div class="d-flex justify-content-center">
                                      <div class="p-0 pt-1 headersize1">
                                        Wrong Answer
                                      </div>
                                      <div
                                        class="p-0"
                                        *ngIf="WrongAnswer3 != null"
                                      >
                                        <!-- <button type="button" *ngIf="WrongAnswer33" class="btn btn-sm bg-light border" (click)="DeleteAnswerChoice(WrongAnswer3)">Delete Answer</button> -->
                                        <button
                                          *ngIf="WrongAnswer33"
                                          (click)="
                                            DeleteAnswerChoice(WrongAnswer3)
                                          "
                                          type="button"
                                          class="btn btn-sm py-0"
                                          style="background: transparent"
                                        >
                                          <i
                                            class="fa fa-trash label-red"
                                            style="font-size: 16px"
                                          ></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-3 px-1">
                                <!-- [ngClass]="{'borderview1': RightAnswer11!=null}" -->
                                <div
                                  class="card"
                                  [ngClass]="{ 'borderview1': RightAnswer11 }"
                                  style="
                                    min-height: auto;
                                    height: 14vh !important;
                                    overflow: auto;
                                  "
                                  (click)="Answerchoicepopup('R')"
                                >
                                  <!-- <div class="card-body" > -->
                                  <!-- <span style="white-space: pre-wrap;" [innerHTML]="RightAnswer11"></span> -->
                                  <div
                                    class="editor py-1 px-1"
                                    *ngIf="RightAnswer11 != null"
                                  >
                                    <div [innerHTML]="RightAnswer11"></div>
                                    <!-- </div> -->
                                  </div>
                                </div>
                              </div>
                              <!-- style="min-height: 10vh !important; overflow: auto;" -->
                              <div class="col-3 px-1">
                                <!-- [ngClass]="{'borderview2': WrongAnswer11!=null}" -->
                                <div
                                  class="card"
                                  [ngClass]="{ 'borderview2': WrongAnswer11 }"
                                  style="
                                    min-height: auto;
                                    height: 14vh !important;
                                    overflow: auto;
                                  "
                                  (click)="Answerchoicepopup('W1')"
                                >
                                  <!-- <div class="card-body"  > -->
                                  <!-- {{WrongAnswer1.Answer_Choice_Body_Text}} -->
                                  <div
                                    class="editor py-1 px-1"
                                    *ngIf="WrongAnswer11 != null"
                                  >
                                    <div [innerHTML]="WrongAnswer11"></div>
                                    <!-- </div> -->
                                  </div>
                                </div>
                              </div>
                              <div class="col-3 px-1">
                                <!-- [ngClass]="{'borderview2': WrongAnswer22!=null}" -->
                                <div
                                  class="card"
                                  [ngClass]="{ 'borderview2': WrongAnswer22 }"
                                  style="
                                    min-height: auto;
                                    height: 14vh !important;
                                    overflow: auto;
                                  "
                                  (click)="Answerchoicepopup('W2')"
                                >
                                  <!-- <div class="card-body"  > -->
                                  <!-- {{WrongAnswer2.Answer_Choice_Body_Text}} -->
                                  <div
                                    class="editor py-1 px-1"
                                    *ngIf="WrongAnswer22 != null"
                                  >
                                    <div [innerHTML]="WrongAnswer22"></div>
                                    <!-- </div> -->
                                  </div>
                                </div>
                              </div>
                              <div class="col-3 px-1">
                                <!-- [ngClass]="{'borderview2': WrongAnswer33!=null}" -->
                                <div
                                  class="card"
                                  [ngClass]="{ 'borderview2': WrongAnswer33 }"
                                  style="
                                    min-height: auto;
                                    height: 14vh !important;
                                    overflow: auto;
                                  "
                                  (click)="Answerchoicepopup('W3')"
                                >
                                  <!-- <div class="card-body" > -->
                                  <!-- {{WrongAnswer3.Answer_Choice_Body_Text}} -->
                                  <div
                                    class="editor py-1 px-1"
                                    *ngIf="WrongAnswer33 != null"
                                  >
                                    <div [innerHTML]="WrongAnswer33"></div>
                                    <!-- </div> -->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-3">
                                <div *ngIf="RightAnswer1 != null">
                                  <div class="d-flex">
                                    <div class="px-1">
                                      <a
                                        [routerLink]="['./']"
                                        *ngIf="
                                          RightAnswer1.Answer_SolutionHintflag
                                        "
                                        (click)="
                                          EditAnswerNotepopup(RightAnswer1, 'Y')
                                        "
                                        class="card-link Answer-card-link"
                                        >Hint</a
                                      >
                                    </div>
                                    <div class="px-1">
                                      <a
                                        [routerLink]="['./']"
                                        *ngIf="RightAnswer1.AnswerNoteflag"
                                        (click)="
                                          EditAnswerNotepopup(RightAnswer1, 'N')
                                        "
                                        class="card-link Answer-card-link"
                                        >Answer Note</a
                                      >
                                    </div>

                                    <!-- <a [routerLink]="['./']" *ngIf="RightAnswer11" (click)="DeleteAnswerChoice(RightAnswer1)" class="card-link Answer-card-link">Delete Answer</a> -->
                                  </div>
                                </div>
                              </div>
                              <div class="col-3">
                                <div *ngIf="WrongAnswer1 != null">
                                  <div class="d-flex">
                                    <!-- <a [routerLink]="['./']" *ngIf="WrongAnswer1.Answer_SolutionHintflag" (click)="EditAnswerNotepopup(WrongAnswer1,'Y')" class="card-link Answer-card-link">Solution Hint</a>
                                <a [routerLink]="['./']" *ngIf="WrongAnswer1.AnswerNoteflag" (click)="EditAnswerNotepopup(WrongAnswer1,'N')" class="card-link Answer-card-link">Answer Note</a> -->
                                  </div>
                                </div>
                              </div>

                              <div class="col-3">
                                <div *ngIf="WrongAnswer2 != null">
                                  <div class="d-flex">
                                    <!-- <a [routerLink]="['./']"  *ngIf="WrongAnswer2.Answer_SolutionHintflag" (click)="EditAnswerNotepopup(WrongAnswer2,'Y')"class="card-link Answer-card-link">Solution Hint</a>
                                <a [routerLink]="['./']"  *ngIf="WrongAnswer2.AnswerNoteflag" (click)="EditAnswerNotepopup(WrongAnswer2,'N')"class="card-link Answer-card-link">Answer Note</a> -->
                                  </div>
                                </div>
                              </div>
                              <div class="col-3">
                                <div *ngIf="WrongAnswer3 != null">
                                  <div class="d-flex">
                                    <!-- <a [routerLink]="['./']"  *ngIf="WrongAnswer3.Answer_SolutionHintflag" (click)="EditAnswerNotepopup(WrongAnswer3,'Y')" class="card-link Answer-card-link">Solution Hint</a>
                                <a [routerLink]="['./']"  *ngIf="WrongAnswer3.AnswerNoteflag" (click)="EditAnswerNotepopup(WrongAnswer3,'N')" class="card-link Answer-card-link">Answer Note</a> -->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="row">
                              <div class="col-3 p-1">
                                <div class="row">
                                  <div class="col-12">
                                    <div class="d-flex justify-content-center">
                                      <div class="p-0 pt-1 headersize1">
                                        Wrong Answer
                                      </div>
                                      <div
                                        class="p-0"
                                        *ngIf="WrongAnswer4 != null"
                                      >
                                        <!-- <button type="button" *ngIf="WrongAnswer44" class="btn btn-sm bg-light border" (click)="DeleteAnswerChoice(WrongAnswer4)">Delete Answer</button> -->
                                        <button
                                          *ngIf="WrongAnswer44"
                                          (click)="
                                            DeleteAnswerChoice(WrongAnswer4)
                                          "
                                          type="button"
                                          class="btn btn-sm py-0"
                                          style="background: transparent"
                                        >
                                          <i
                                            class="fa fa-trash label-red"
                                            style="font-size: 16px"
                                          ></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-3 p-1">
                                <div class="row">
                                  <div class="col-12">
                                    <div class="d-flex justify-content-center">
                                      <div class="p-0 pt-1 headersize1">
                                        Wrong Answer
                                      </div>
                                      <div
                                        class="p-0"
                                        *ngIf="WrongAnswer5 != null"
                                      >
                                        <!-- <button type="button" *ngIf="WrongAnswer55" class="btn btn-sm bg-light border" (click)="DeleteAnswerChoice(WrongAnswer5)">Delete Answer</button> -->
                                        <button
                                          *ngIf="WrongAnswer55"
                                          (click)="
                                            DeleteAnswerChoice(WrongAnswer5)
                                          "
                                          type="button"
                                          class="btn btn-sm py-0"
                                          style="background: transparent"
                                        >
                                          <i
                                            class="fa fa-trash label-red"
                                            style="font-size: 16px"
                                          ></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-3 p-1">
                                <div class="row">
                                  <div class="col-12">
                                    <div class="d-flex justify-content-center">
                                      <div class="p-0 pt-1 headersize1">
                                        Wrong Answer
                                      </div>
                                      <div
                                        class="p-0"
                                        *ngIf="WrongAnswer6 != null"
                                      >
                                        <!-- <button type="button" *ngIf="WrongAnswer66" class="btn btn-sm bg-light border" (click)="DeleteAnswerChoice(WrongAnswer6)">Delete Answer</button> -->

                                        <button
                                          *ngIf="WrongAnswer66"
                                          (click)="
                                            DeleteAnswerChoice(WrongAnswer6)
                                          "
                                          type="button"
                                          class="btn btn-sm py-0"
                                          style="background: transparent"
                                        >
                                          <i
                                            class="fa fa-trash label-red"
                                            style="font-size: 16px"
                                          ></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-3 p-1">
                                <div class="row">
                                  <div class="col-12">
                                    <div class="d-flex justify-content-center">
                                      <div class="p-0 pt-1 headersize1">
                                        Wrong Answer
                                      </div>
                                      <div
                                        class="p-0"
                                        *ngIf="WrongAnswer7 != null"
                                      >
                                        <!-- <button type="button" *ngIf="WrongAnswer77" class="btn btn-sm bg-light border" (click)="DeleteAnswerChoice(WrongAnswer7)">Delete Answer</button> -->
                                        <button
                                          *ngIf="WrongAnswer77"
                                          (click)="
                                            DeleteAnswerChoice(WrongAnswer7)
                                          "
                                          type="button"
                                          class="btn btn-sm py-0"
                                          style="background: transparent"
                                        >
                                          <i
                                            class="fa fa-trash label-red"
                                            style="font-size: 16px"
                                          ></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-3 pr-2 px-1">
                                <!-- [ngClass]="{'borderview2': WrongAnswer44!=null}" -->
                                <div
                                  class="card"
                                  [ngClass]="{ 'borderview2': WrongAnswer44 }"
                                  style="
                                    min-height: auto;
                                    height: 14vh !important;
                                    overflow: auto;
                                  "
                                  (click)="Answerchoicepopup('W4')"
                                >
                                  <!-- <div class="card-body"  > -->
                                  <!-- {{WrongAnswer4.Answer_Choice_Body_Text}} -->
                                  <div
                                    class="editor py-1 px-1"
                                    *ngIf="WrongAnswer44 != null"
                                  >
                                    <div [innerHTML]="WrongAnswer44"></div>
                                    <!-- </div> -->
                                  </div>
                                </div>
                              </div>
                              <div class="col-3 px-1">
                                <!-- [ngClass]="{'borderview2': WrongAnswer55!=null}" -->
                                <div
                                  class="card"
                                  [ngClass]="{ 'borderview2': WrongAnswer55 }"
                                  style="
                                    min-height: auto;
                                    height: 14vh !important;
                                    overflow: auto;
                                  "
                                  (click)="Answerchoicepopup('W5')"
                                >
                                  <!-- <div class="card-body" > -->
                                  <!-- {{WrongAnswer5.Answer_Choice_Body_Text}} -->
                                  <div
                                    class="editor py-1 px-1"
                                    *ngIf="WrongAnswer55 != null"
                                  >
                                    <div [innerHTML]="WrongAnswer55"></div>
                                    <!-- </div> -->
                                  </div>
                                </div>
                              </div>
                              <div class="col-3 px-1">
                                <!-- [ngClass]="{'borderview2': WrongAnswer66!=null}" -->
                                <div
                                  class="card"
                                  [ngClass]="{ 'borderview2': WrongAnswer66 }"
                                  style="
                                    min-height: auto;
                                    height: 14vh !important;
                                    overflow: auto;
                                  "
                                  (click)="Answerchoicepopup('W6')"
                                >
                                  <!-- <div class="card-body" > -->
                                  <!-- {{WrongAnswer6.Answer_Choice_Body_Text}} -->
                                  <div
                                    class="editor py-1 px-1"
                                    *ngIf="WrongAnswer66 != null"
                                  >
                                    <div [innerHTML]="WrongAnswer66"></div>
                                    <!-- </div> -->
                                  </div>
                                </div>
                              </div>
                              <div class="col-3 px-1">
                                <!-- [ngClass]="{'borderview2': WrongAnswer77!=null}" -->
                                <div
                                  class="card"
                                  [ngClass]="{ 'borderview2': WrongAnswer77 }"
                                  style="
                                    min-height: auto;
                                    height: 14vh !important;
                                    overflow: auto;
                                  "
                                  (click)="Answerchoicepopup('W7')"
                                >
                                  <!-- <div class="card-body" > -->
                                  <!-- {{WrongAnswer7.Answer_Choice_Body_Text}} -->
                                  <div
                                    class="editor py-1 px-1"
                                    *ngIf="WrongAnswer77 != null"
                                  >
                                    <div [innerHTML]="WrongAnswer77"></div>
                                  </div>
                                  <!-- </div> -->
                                </div>
                              </div>
                            </div>
                            <div class="row py-1">
                              <div class="col-3">
                                <div *ngIf="WrongAnswer4 != null">
                                  <div
                                    class="d-flex justify-content-between px-1"
                                  >
                                    <!-- <a [routerLink]="['./']" *ngIf="WrongAnswer4.Answer_SolutionHintflag" (click)="EditAnswerNotepopup(WrongAnswer4,'Y')" class="card-link Answer-card-link">Solution Hint</a>
                                <a [routerLink]="['./']" *ngIf="WrongAnswer4.AnswerNoteflag" (click)="EditAnswerNotepopup(WrongAnswer4,'N')" class="card-link Answer-card-link">Answer Note</a> -->
                                  </div>
                                </div>
                              </div>
                              <div class="col-3">
                                <div *ngIf="WrongAnswer5 != null">
                                  <div
                                    class="d-flex justify-content-between px-1"
                                  >
                                    <!-- <a [routerLink]="['./']" *ngIf="WrongAnswer5.Answer_SolutionHintflag" (click)="EditAnswerNotepopup(WrongAnswer5,'Y')" class="card-link Answer-card-link">Solution Hint</a>
                                <a [routerLink]="['./']" *ngIf="WrongAnswer5.AnswerNoteflag" (click)="EditAnswerNotepopup(WrongAnswer5,'N')" class="card-link Answer-card-link">Answer Note</a> -->
                                  </div>
                                </div>
                              </div>
                              <div class="col-3">
                                <div *ngIf="WrongAnswer6 != null">
                                  <div
                                    class="d-flex justify-content-between px-1"
                                  >
                                    <!-- <a [routerLink]="['./']" *ngIf="WrongAnswer6.Answer_SolutionHintflag" (click)="EditAnswerNotepopup(WrongAnswer6,'Y')" class="card-link Answer-card-link">Solution Hint</a>
                                <a [routerLink]="['./']" *ngIf="WrongAnswer6.AnswerNoteflag" (click)="EditAnswerNotepopup(WrongAnswer6,'N')" class="card-link Answer-card-link">Answer Note</a> -->
                                  </div>
                                </div>
                              </div>
                              <div class="col-3">
                                <div *ngIf="WrongAnswer7 != null">
                                  <div
                                    class="d-flex justify-content-between px-1"
                                  >
                                    <!-- <a [routerLink]="['./']" *ngIf="WrongAnswer7.Answer_SolutionHintflag" (click)="EditAnswerNotepopup(WrongAnswer7,'Y')" class="card-link Answer-card-link">Solution Hint</a>
                                <a [routerLink]="['./']" *ngIf="WrongAnswer7.AnswerNoteflag" (click)="EditAnswerNotepopup(WrongAnswer7,'N')" class="card-link Answer-card-link">Answer Note</a> -->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- </div> -->
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-8">
            <div class="d-flex justify-content-start pt-1">
              <div class="px-1" *ngIf="safehtmlStr">
                <button
                  type="button"
                  [disabled]="!safehtmlStr"
                  class="btn btn-sm bg-light border"
                  (click)="clkQuestionPreview()"
                >
                  Preview
                </button>
              </div>
              <div
                class="px-1"
                *ngIf="
                  questionStatusTypeCode == 'Submitted'
                "
              >
                <button
                  type="button"
                  class="btn btn-sm bg-light border"
                  (click)="ClkReviewQuestion('Approved')"
                >
                  Approve
                </button>
              </div>

              <div
                class="px-1"
                *ngIf="
                  questionStatusTypeCode == 'Submitted'
                "
              >
                <button
                  type="button"
                  (click)="ClkReviewQuestion('Defer')"
                  class="btn btn-sm bg-light border"
                >
                  Deferred
                </button>
              </div>

              <div class="px-1">
                <button
                  type="button"
                  [hidden]="
                    questionStatusTypeCode != 'WIP' &&
                    questionStatusTypeCode != 'Rework'
                  "
                  [disabled]="
                    !AddQuestionform.valid ||
                    (EditQuestionFlag &&
                      AddQuestionform.valid &&
                      !tempvariable) ||
                    (NextButtonflag &&
                      AddQuestionform.valid &&
                      !tempvariable &&
                      QuestionBodyflag) ||
                    (questionStatusTypeCode != 'WIP' &&
                      questionStatusTypeCode !=
                        'Rework')
                  "
                  (click)="AddQuestionHeader()"
                  class="btn btn-sm bl-btn"
                >
                  Save
                </button>
              </div>
              <div
                class="px-1"
                *ngIf="
                  safehtmlStr &&
                  questionStatusTypeCode == 'WIP'
                "
              >
                <button
                  type="button"
                  *ngIf="
                    questionStatusTypeCode == 'WIP'
                  "
                  [disabled]="!QuestionBodyflag || tempvariable || !safehtmlStr"
                  class="btn btn-sm bg-light border"
                  (click)="ClkReviewQuestion('Submitted')"
                >
                  Submit for Review
                </button>
              </div>
              <div
                class="px-1"
                *ngIf="
                  questionStatusTypeCode != 'Submitted'
                "
              >
                <button
                  type="button"
                  [hidden]="
                    questionStatusTypeCode ==
                      'Submitted' ||
                    !AddQuestionform.value.Question_ID ||
                    !safehtmlStr
                  "
                  [disabled]="
                    !AddQuestionform.value.Question_ID || !safehtmlStr
                  "
                  class="btn btn-sm bg-light border"
                  (click)="relocatepopup()"
                >
                  Relocate
                </button>
              </div>



              <div
                class="px-1"
                *ngIf="
                  questionStatusTypeCode == 'Submitted'
                "
              >
                <button
                  type="button"
                  class="btn btn-sm bg-light border"
                  (click)="ClkReviewQuestion('Rework')"
                >
                  Suggest Rework
                </button>
              </div>

              <div
                class="px-1"
                *ngIf="
                  questionStatusTypeCode == 'Submitted'
                "
              >
                <button
                  type="button"
                  class="btn btn-sm bg-light border"
                  (click)="ClkReviewQuestion('Rejected')"
                >
                  Reject
                </button>
              </div>
            </div>
          </div>
          <div class="col-4 px-3" *ngIf="!NextButtonflag">
            <div class="d-flex justify-content-end pt-1">
              <div class="px-1">
                <button
                type="button"
                title="Assign Question to Courses"
                class="btn btn-sm bg-light border"
                (click)="AssignCourses()"
              >
                Assign Question
              </button>
                </div>
              <div class="px-1">
                <button
                  type="button"
                  class="btn btn-sm bg-light border"
                  [disabled]="Previousflag"
                  (click)="PreviousflagButton()"
                >
                  Previous Question
                </button>
              </div>

              <div class="px-1">
                <button
                  type="button"
                  class="btn btn-sm bg-light border"
                  [disabled]="Nextflag"
                  (click)="NextButton()"
                >
                  Next Question
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="col-12" *ngIf="questionStatusTypeCode=='Submitted'">
            <div class="row pt-1">
        <div class="col-6" >
          <div class=" d-flex justify-content-center pt-3">
            <div class="px-1">
              <button type="button"  class="btn btn-sm bg-light border" (click)="ClkReviewQuestion('Approved')">Approve</button>
            </div>
            <div class="px-1">
              <button type="button"  (click)="ClkReviewQuestion('Defer')"
                class="btn btn-sm bg-light border">Deferred</button>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="d-flex justify-content-center pt-3">
            <div class="px-1">
              <button type="button"   class="btn btn-sm bg-light border" (click)="ClkReviewQuestion('Rework')">Suggest Rework</button>
            </div>
            <div class="px-1">
              <button type="button"  class="btn btn-sm bg-light border" (click)="ClkReviewQuestion('Rejected')">Reject</button>
            </div>
          </div>
        </div>
        </div>
      </div> -->
      </form>
    </div>
  </div>
</div>
<div
  class="modal fade show modal-dialog-centered"
  style="padding-right: 4px; display: block; background-color: #00000075"
  *ngIf="deletealertpopup"
>
  <div class="modal-dialog modal-dialog-alert modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Alert</h6>
        <button
          type="button"
          class="close"
          (click)="DeleteAnswerchoicepopup()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <div class="row py-2 mx-2 pt-3">
          <div class="col-12">
            <label>Do you want to delete the Answer ?</label>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <div class="px-1">
                <button
                  type="button"
                  (click)="replacedeletebutton()"
                  class="btn btn-sm bl-btn"
                >
                  Yes
                </button>
              </div>
              <div class="px-1">
                <button
                  type="button"
                  (click)="CloseDeleteAlertpopup()"
                  class="btn btn-sm bg-light border"
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade show Model_popup1" *ngIf="relocatepopupflag">
  <div class="modal-dialog modal-dialog-centered modal-dialog-EditRelocate">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">
          Relocate Question
        </h6>
        <button
          type="button"
          class="close"
          (click)="relocatepopup()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <div class="col-12 d-flex">
          <div class="pl-1 pt-1 headersize">Current Location:</div>
          <div class="pr-1 headersize">
            <app-breadcrumb [Breadcrumblist]="Breadcrumblist"></app-breadcrumb>
          </div>
        </div>
        <div class="col-12" *ngIf="relocatepopupflag === true">
          <div class="row" *ngIf="relocatepopupflag">
            <div class="col-12">
              <app-relocate-question
                (CloseEdit)="CloseEdit($event)"
                (CloseRelocateQuestion)="CloseRelocateQuestion($event)"
                [getQuestionByIDlist]="getQuestionByIDlist"
                [subjectById]="subjectById"
              ></app-relocate-question>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade show Model_popup1" *ngIf="QuestionUsagepopupflag">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Edit1">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">
          Question Usage Setting
        </h6>
        <button
          type="button"
          class="close"
          (click)="CloseQuestionUsage()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-question-usage-setting
          (closequestionusage)="closequestionusage($event)"
          [selectedQuestionById]="selectedQuestionById"
          [subjectById]="subjectById"
        ></app-question-usage-setting>
      </div>
    </div>
  </div>
</div>
<!-- <div class="modal fade  show modal-dialog-centered"style="padding-right: 4px;display: block;background-color: #00000075;" *ngIf="relocatepopupflag">
  <div class="modal-dialog modal-dialog-alert modal-dialog-Edit">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Relocate Question</h6>
        <button type="button" class="close" (click)="relocatepopup()"
          style="padding-right: 20px;font-size: 30px;outline: 0;">
          <span aria-hidden="true">&times;</span></button>
      </div>

      <div class="modal-body px-3 py-0">
        <div class="col-12 d-flex">
          <div class="pl-1 pt-1">Current Location:</div>
          <div class="pr-1">
            <app-breadcrumb [Breadcrumblist]="Breadcrumblist"></app-breadcrumb>
          </div>
        </div>
        <div class="col-12" *ngIf="relocatepopupflag === true">
          <div class="row" *ngIf="relocatepopupflag">
            <div class="col-12">
              <app-relocate-question [subjectById]="subjectById" ></app-relocate-question>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div> -->

<!-- <div class="modal fade show" id="model" *ngIf="relocatepopupflag" [hidden]="!relocatepopupflag"
style="padding-right: 4px;display: block;background-color: #00000075">
<div class="modal-dialog modal-dialog-centered modal-dialog-Edit" role="document">
  <div class="modal-content">
    <div class="modal-body pt-0">
      <div class="row Page-Header">
        <div class="col-8">
          <h6 class="HeadContent">Relocate Question</h6>
        </div>
        <div class="col-4 d-flex flex-row-reverse">
            <div class="px-1">
              <button type="button" class="close" (click)="relocatepopup()" style="font-size: 26px;outline: 0;">
                <span aria-hidden="true">&times;</span></button>
            </div>

        </div>
      </div>
      <div class="col-12 d-flex">
        <div class="pl-1 pt-1">Current Location:</div>
        <div class="pr-1">
          <app-breadcrumb [Breadcrumblist]="Breadcrumblist"></app-breadcrumb>
        </div>
      </div>
      <div class="col-12" *ngIf="relocatepopupflag === true">
        <div class="row" *ngIf="relocatepopupflag">
          <div class="col-12">
            <app-relocate-question [subjectById]="subjectById" ></app-relocate-question>
          </div>
        </div>
      </div>
  </div>
  </div>
</div>
</div> -->
<div
  class="modal fade show modal-dialog-centered"
  style="padding-right: 4px; display: block; background-color: #00000075"
  *ngIf="alertpopupflag"
>
  <div class="modal-dialog modal-dialog-alert1 modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Save Changes</h6>
        <button
          type="button"
          class="close"
          style="padding-right: 20px; font-size: 30px; outline: 0"
          (click)="Alertpopup()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <div class="row py-2 mx-2 pt-3">
          <div class="col-12">
            <label>Would you like to Save Changes ?</label>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <div class="px-1">
                <button
                  type="button"
                  class="btn btn-sm bl-btn"
                  (click)="Savecontent()"
                >
                  Save
                </button>
              </div>
              <div class="px-1">
                <button
                  type="button"
                  class="btn btn-sm bg-light border"
                  (click)="alertclose()"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
